<template>
  <div class="bg-F6F6F6 leave-list">
    <ul>
      <li v-for="item in list" :key="item.leaveId" class="mb-12 bg-FFFFFF">
        <div class="fb fb-main-between fb-cross-baseline pl-16">
          <common-time
            class="leave-time font-32 c-191F25-60"
            :time="item.startTime"
            format="hh:mm"
          ></common-time>
          <md-list class="item-flex-1 hidden" arrow>
            <md-list-item @click="handlerClickItem(item)">
              <div
                slot="title"
                class="fb fb-cross-center fb-main-start fb-wrap"
              >
                <span
                  v-if="computedIsLongLeave(item)"
                  class="leave-long-term font-32"
                  >[长期]</span
                >
                <span class="leave-student-name font-36">
                  {{ filterName(item.personName, 5) }}
                </span>
                <span
                  class="leave-type p-0-8 lh-18 fb fb-row fb-cross-center fb-main-center font-26"
                  :class="{ 'mt-6': (item.leaveTypeName || '').length > 3 }"
                  >{{ item.leaveTypeName }}</span
                >
              </div>
              <span slot="description">
                <common-leave-status
                  class="font-30"
                  :status="item.approveStatus"
                ></common-leave-status
              ></span>
            </md-list-item>
            <!-- 返校证明状态 1：未上传 2：待审核 3：已通过 4：已拒绝 5: 已失效  -->
            <md-list-item
              v-if="
                allowLeaveBackCertificate
                  ? item.backSchoolStatus > 0
                  : item.backSchoolStatus > 1
              "
              @click="
                handlerClickList(
                  item.backSchoolStatus,
                  item.dingPersonId,
                  item.leaveId
                )
              "
            >
              <span slot="title" class="font-30">返校证明</span>
              <span
                class="font-30"
                slot="description"
                :style="{
                  color: BACK_SCHOOL_STATUS[+item.backSchoolStatus].color
                }"
                >{{ BACK_SCHOOL_STATUS[+item.backSchoolStatus].content }}</span
              >
            </md-list-item>
          </md-list>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import mixin from '@/mixin'
import commonLeaveStatus from './commonLeaveStatus'
import commonTime from './commonTime'
import { timeFormat, getItem, filterName } from '@/utils/comUtils'

import {
  SEX_TYPE,
  ACCMMODATION_TYPE,
  BACK_SCHOOL_STATUS
} from '@/utils/constUtils'

export default {
  mixins: [mixin],
  name: 'commonLeaveList',
  components: { commonLeaveStatus, commonTime },
  props: {
    list: Array,
    // 2: 修改或撤销请假列表
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      getItem,
      filterName,
      SEX_TYPE,
      ACCMMODATION_TYPE,
      BACK_SCHOOL_STATUS
    }
  },
  computed: {
    computedIsLongLeave() {
      return item => {
        let _isLong = false
        let _start = timeFormat(new Date(item.startTime), 'YYYY-MM-DD')
        _start = new Date(_start.replace(/-/g, '/')).getTime()
        let _end = item.endTime

        if (_end - _start >= 24 * 60 * 60 * 1000) {
          _isLong = true
        }

        return _isLong
      }
    },
    allowLeaveBackCertificate() {
      return this.$store.getters.allowLeaveBackCertificate
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerClickItem(item) {
      this.$emit('click', item)
    },
    handlerClickList(backSchoolStatus, studentDingIds, leaveId) {
      let url = '/leave/backdetail'
      //  返校证明状态 1：未上传 2：待审核 3：已通过 4：已拒绝 5: 已失效
      if (this.allowLeaveBackCertificate) {
        const _goBack =
          (this.curIsGuardian || this.isStudent) && backSchoolStatus === 1
        _goBack && (url = '/leave/back')
      }

      this.$emit('clickBack', url, studentDingIds, leaveId)
    }
  }
}
</script>

<style lang="scss" scoped>
.leave-list {
  width: 100%;
  .leave-time {
    display: inline-block;
    height: 24px;
    min-width: 68px;
    line-height: 24px;
    text-align: center;
    background: #f6f6f6;
    border-radius: 26px;
    margin-right: 6px;
  }

  .leave-long-term {
    display: inline-block;
    color: #15bc83;
    margin-right: 6px;
    min-width: 42px;
  }

  .leave-student-name {
    color: #191f25;
    margin-right: 6px;
  }

  .leave-type {
    display: inline-block;
    text-align: center;
    height: 20px;
    min-width: 42px;
    color: #006afe;
    border: 1px solid #006afe;
    border-radius: 3px;
  }
}
.leave-back {
  margin-left: 76px;
}
:deep .md-list-item .md-list-item__inner--title {
  height: auto !important;
}
</style>
